import { 
    DELETE_TEAM_MEMBER, UPDATE_TEAM_MEMBER, ADD_TEAM_MEMBER, FETCH_TEAM
} from './actionTypes';


const addTeamMember = (payload) => ({
    type: ADD_TEAM_MEMBER,
    payload,
    errors: null
});


const updateTeamMember = (payload) => ({
    type:  UPDATE_TEAM_MEMBER,
    payload,
    errors: null
});


const deleteTeamMember = (personId) => ({
    type: DELETE_TEAM_MEMBER,
    payload: { personId },
    errors: null
});


const fetchTeam = () => ({
    type: FETCH_TEAM,
    payload: {},
    errors: null
})


export {
    addTeamMember, updateTeamMember, deleteTeamMember, fetchTeam
};